import MuiBadge, { BadgeProps as MuiBadgeProps } from "@mui/material/Badge";
import React from "react";

const Badge: React.FC<MuiBadgeProps> = (props) => {
  return <MuiBadge {...props} />;
};

export default Badge;
